import { configs } from "../config";
import { commonFunctions } from "../_utilities/commonFunctions";
import { configes } from "../webData";

export const pageService = {
  getPages,
};

function getPages(query = "?section=terms&section=privacy") {
  const requestOptions = commonFunctions.getRequestOptions("GET");
  return fetch(
    `${configs.localApiUrl}/getPage/${configes.domainId}${query}`,
    requestOptions
  ).then((response) => response.json());
}
